module.exports = {
      id: "icon-audio-next-usage",
      viewBox: "0 0 35.504 35.504",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#icon-audio-next",
      toString: function () {
        return this.url;
      }
    }